import { animate, style, transition, trigger } from '@angular/animations';

export const routeAnimation = trigger('route', [
  transition('* <=> *', [
    style({ transform: 'translateX(50px)', opacity: 0 }),
    animate('250ms', style({ transform: 'translateX(0)', opacity: 1 }))
  ])
]);
